import {Component, inject, OnInit, signal} from "@angular/core";
import {SnackbarComponent} from "@common/ui/snackbar/snackbar.component";
import {Translations} from "@translations";
import {TranslateModule, TranslateService} from "@ngx-translate/core";
import {TranslationKey} from "@models";
import {MAT_SNACK_BAR_DATA} from "@angular/material/snack-bar";

export interface ErrorSnackbarData {
	translationKey?: TranslationKey;
	translationArgs?: string[];
	duration: number;
}

@Component({
	selector: "sim-error-snackbar",
	imports: [SnackbarComponent, TranslateModule],
	templateUrl: "./error-snackbar.component.html",
	styleUrl: "./error-snackbar.component.scss",
})
export class ErrorSnackbarComponent implements OnInit {
	// Properties
	protected errorMessage = signal<string>(Translations.ERROR_UNKNOWN_SERVER_ERROR);

	// Injections
	readonly translate = inject(TranslateService);
	readonly data = inject<ErrorSnackbarData>(MAT_SNACK_BAR_DATA);

	public ngOnInit(): void {
		this.interpolateTranslation();
	}

	private interpolateTranslation(): void {
		if (this.data.translationKey) {
			const interpolationObject = this.arrayToObject(this.data.translationArgs);
			this.errorMessage.set(this.translate.instant(this.data.translationKey, interpolationObject));
		}
	}

	private arrayToObject(arr?: string[]): {[key: number]: string} {
		if (!arr?.length) {
			return {};
		}
		const result: {[key: number]: string} = {};
		arr.forEach((value, index) => {
			result[index] = `<strong>${value}</strong>`;
		});
		return result;
	}
}
